import * as React from 'react'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

const bannerContainerCss = css`
  align-items: center;
  background-color: rgba(20, 20, 20, 0.6);
  border-radius: 20px;
  border: 1px solid ${theme.color.neutral90};
  bottom: -120px;
  box-shadow: 0px 2px 4px rgba(41, 41, 41, 0.2);
  box-sizing: border-box;
  color: ${theme.color.white};
  display: flex;
  justify-content: center;
  left: 50%;
  padding: 18px 20px;
  position: fixed;
  right: auto;
  transform: translateX(-50%);
  width: max-content;

  button {
    background: ${theme.color.brandEmeraldGreen};

    &:hover:enabled,
    &:focus-visible:enabled {
      background: ${theme.color.brandEmeraldGreen};
      color: ${theme.color.black};
      filter: brightness(0.9);

      svg {
        fill: ${theme.color.black};
      }
    }
  }
`

export interface BannerProps {
  readonly children: React.ReactNode
}

export function Banner({ children }: BannerProps) {
  return <div className={bannerContainerCss}>{children}</div>
}
